import { BACKEND_PRIVATE } from '../base'

export async function getBalance() {
  return BACKEND_PRIVATE.get<Record<number, string | number>>('/me/timewarp/earns/balance')
}

export async function getWithdraws() {
  return BACKEND_PRIVATE.get<LX.TimewarpWithdrawalRequest[]>('/me/timewarp/withdraws/list')
}

export async function getReferrals(params?: { limit?: number; offset?: number }) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ referrals: LX.Referral[] }>>('/me/timewarp/earns/referral-details', { params })
}

export async function createWithdraw(params: { wallet: string }) {
  return BACKEND_PRIVATE.post('/me/timewarp/withdraws/create', null, { params })
}
